<!-- eslint-disable vue/valid-template-root -->
<template lang="html">
  <Row>
    <Col :span="24">
          <Card class="card-box card-height">
              <div class="text-center" v-if="isTripHaltDurationLoading">
                  <Spinner/>
              </div>
              <div class="status-msg" v-else-if="!tripHaltDuration">
                  <span>
                    <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
                    <p class="mt-0 ml-30">No data available</p>
                  </span>
              </div>
              <Row :gutter="40" v-else>
              <Col :span="12">
                  <div class="header-text">
                      Halt Duration
                  </div>
                  <Graph
                  :graphDetail="tripHaltDuration"
                  :headerConstant="constructBars(tripHaltDuration)"
                  :multiline="true"
                  >
                  </Graph>
              </Col>

              <Col :span="12">
                  <Row :gutter="40" class="list-bordered divider col-pt-15">
                      <Col :span="8"  v-for="header in constructHeaders(tripHaltDuration)" :key="header.id" :class="header.class">
                        <Tooltip v-if="getTooltipText[header.column]" :open-delay="100" popper-class="max-width"  effect="dark" placement="top">
                          <div slot="content">
                              <span v-html="getTooltipText[header.column]"></span>
                          </div>
                          <ColCell
                          :header="header"
                          :value="tripHaltDuration[header.column]"
                          @routeToTrack="$emit('routeToTrack', { routeCategory: header.routeCategory, type: header.type, header: $event })"
                          >
                          </ColCell>
                        </Tooltip>
                      </Col>
                  </Row>

              </Col>
              </Row>
          </Card>
      </Col>
  </Row>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import Graph from '@/components/track/Graph';
import {
  etaDetailsHeaders,
  etaBarChartConstants,
  tripHaltBarChartConstants,
  tripHaltDurationHeaders,
} from '@/constants/trackConstants';
import { LocationTracker } from 'pando-constants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';


export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  async created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  data() {
    return {
      etaDetailsHeaders,
      etaBarChartConstants,
      tripHaltDuration: null,
      isTripHaltDurationLoading: true,
      fromToData: [],
    };
  },
  props: ['queryParams', 'dashboardConfigs', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  computed: {
    getTooltipText() {
      const tooltipTextsMap = {};
      const tripHaltDurationKeys = Object.keys(this.tripHaltDuration || {});
      const durationUnit = this.getDurationUnit() === LocationTracker.MINUTES_UNIT ? 'mins' : 'hrs';
      if (tripHaltDurationKeys && tripHaltDurationKeys.length) {
        tripHaltDurationKeys.reduce((acc, tripRange) => {
          const [fromTime = 0, toTime = 0] = tripRange.split('_');
          const text = `Active trips which had halt of ${fromTime || 0} ${toTime ? `- ${toTime}` : '+'}
            ${durationUnit} duration`;
          acc[tripRange] = text;
          return acc;
        }, tooltipTextsMap);
      }
      return tooltipTextsMap;
    },
  },
  methods: {
    async search() {
      const resultObj = 'tripHaltDuration';
      const loadingObj = 'isTripHaltDurationLoading';
      const section = 'tripHaltDuration';
      const params = this.queryParams;
      this[loadingObj] = true;
      const result = await this.$store.dispatch('track/getDashboardDetails', {
        section,
        params,
      });
      if (result && !result.error) {
        this[resultObj] = result;
      } else {
        this[resultObj] = null;
      }
      this[loadingObj] = false;
    },
    getDurationUnit() {
      return this.dashboardConfigs.widgets.trip_halt_duration &&
        this.dashboardConfigs.widgets.trip_halt_duration.unit;
    },
    constructBars(tripHaltDurations = {}) {
      const bars = [];
      const tripHaltRanges = Object.keys(tripHaltDurations);
      const durationUnit = this.getDurationUnit() === LocationTracker.MINUTES_UNIT ? 'MINS' : 'HRS';
      if (tripHaltRanges.length) {
        tripHaltRanges.sort((a, b) => b - a);
        tripHaltRanges.forEach((range, id) => {
          const [fromTime = 0, toTime = 0] = range.split('_');
          const label = `${fromTime || 0} ${toTime ? `- ${toTime}` : '+'} ${durationUnit}`;
          bars.push({ ...tripHaltBarChartConstants.bars[id], label, labelColumn: range });
        });
      }
      return { bars };
    },
    constructHeaders(tripHaltDurations = {}) {
      const headers = [];
      const tripHaltRanges = Object.keys(tripHaltDurations);
      const durationUnit = this.getDurationUnit() === LocationTracker.MINUTES_UNIT ? 'mins' : 'hrs';
      if (tripHaltRanges.length) {
        tripHaltRanges.sort((a, b) => b - a);
        tripHaltRanges.forEach((range, id) => {
          const [fromTime = 0, toTime = 0] = range.split('_');
          const title = `${fromTime || 0} ${toTime ? `- ${toTime}` : '+'} ${durationUnit}`;
          headers.push({ ...tripHaltDurationHeaders[id], title, column: range, type: range });
        });
      }
      return headers;
    },
  },
};
</script>
